export interface ProductsAvailed {
    Id: string;
    Type: string;
    Name: string;
    DateAvailed: string;
    Amount: number;
    StartDate: string;
    Status: string;
    ProductImageUrl: string[];
    AgreementImageUrl: string;
}

export enum ProductsAvailedStatus {
    PendingTopup = 'Pending Top-up',
    PendingRelease = 'Pending Release',
    Active = 'Active',
    Suspended = 'Suspended',
    Cancelled = 'Cancelled',
    Completed = 'Completed',
    ForCollections = 'For Collections'
}

export interface ProductTransactions {
    Id: string;
    Status: string;
    TransactionDate: string;
    StandardAging: number;
    ProductId: string;
    Name: string;
    AmountDeducted: number;
    Frequency: string;
    DueDate: string;
    Balance: number;
}

export interface ProductHistory {
    Date: string;
    Activity: string;
    Reason: string;
    UpdatedBy: string;
    Remarks: string;
}

export const PRODUCT_HISTORY: ProductHistory[] = [
    {Date: '3/20/25', Activity: 'Released',  Reason: 'Lorem Ipsum', UpdatedBy: 'Charles Leclerc', Remarks: 'Lorem Ipsum'},
    {Date: '3/23/25', Activity: 'Created',  Reason: 'Lorem Ipsum', UpdatedBy: 'Max Verstappen', Remarks: 'Lorem Ipsum'},
    {Date: '3/20/25', Activity: 'Released',  Reason: 'Lorem Ipsum', UpdatedBy: 'Charles Leclerc', Remarks: 'Lorem Ipsum'},
    {Date: '3/23/25', Activity: 'Created',  Reason: 'Lorem Ipsum', UpdatedBy: 'Max Verstappen', Remarks: 'Lorem Ipsum'},
];

export enum TransactionsStatus {
    Paid = 'Paid',
    Failed = 'Failed',
    Overdue = 'Overdue',
    ForCollections = 'For Collections'
}

export enum HistoryStatus {
    Released = 'Released',
    Created = 'Created'
}

export interface walletTransactions {
    Name: string;
    Program: string;
    Date: string;
    Id: string;
    Amount: number;
    Status: string;
}

export const WALLET_TRANSACTIONS: walletTransactions[] = [
    {Name: 'Samsung A16', Program: 'Gadget Program', Date: '3/22/25 12:36pm', Id: '002000139402', Amount: -500, Status: 'Paid'},
    {Name: 'Samsung A16', Program: 'Gadget Program', Date: '3/22/25 12:36pm', Id: '002000139402', Amount: 0, Status: 'Failed - Insufficient Funds'},
    {Name: 'Samsung A16', Program: 'Gadget Program', Date: '3/22/25 12:36pm', Id: '002000139402', Amount: -100, Status: 'Overdue'},
    {Name: 'Samsung A16', Program: 'Gadget Program', Date: '3/22/25 12:36pm', Id: '002000139402', Amount: -100, Status: 'Penalty'}
];
